import { DeployPurchase } from './../interfaces/purchase.model';
import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subscriber, Subscription } from 'rxjs';
import { GenresService } from './genres.service';
import { GenreModelWithURL } from '../interfaces/movie.model';
import { filter, map, retry } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { HelperService } from './helper.service';
import { menuItem } from '../interfaces/menuItem.model';

@Injectable({
  providedIn: 'root',
})
export class NavbarService {
  constructor(private genresService: GenresService, private helperService: HelperService) {
    this.getGeneros()
  }

  private menuActive = new BehaviorSubject<boolean>(false);
  private modalSelected = new BehaviorSubject<string>(null);
  private cerrarModalesEvent = new BehaviorSubject<boolean>(false);

  public $menuActive = this.menuActive.asObservable();
  public $abrirModal = this.modalSelected.asObservable();
  public $cerrarModales = this.cerrarModalesEvent.asObservable();


  async getMenu(): Promise<menuItem[]> {
    return [
      {
        name: 'Archivo fílmico',
        path: '/filmic-archive',
        type: 'routerLink',
        listType: null,
        list: [],
      },
      {
        name: 'Preguntas frecuentes',
        path: '/faq',
        type: 'routerLink',
        listType: null,
        list: [],
      },
      {
        name: 'Suscripciones',
        path: '/membership-info',
        type: 'routerLink',
        listType: null,
        list: [],
      },
      {
        name: 'Salas',
        path: 'https://cinemateca.org.uy/',
        type: 'normal',
        listType: null,
        list: [],
        external: true
      },
      {
        name: 'Catálogo',
        path: '/catalogue',
        type: 'routerLink',
        listType: null,
        list: [],
      },
      {
        name: 'Reconecta',
        path: '/reconnect',
        type: 'routerLink',
        listType: null,
        list: [],
      },
      {
        name: 'Sala de prensa',
        path: '/sala-de-prensa',
        type: 'routerLink',
        listType: null,
        list: []
      },
      {
        name: 'Félix Oliver',
        path: '/felix-oliver',
        type: 'routerLink',
        listType: null,
        list: []
      },
    ];
  }

  //Si es Felix Oliver tiene otro menu
  async getMenuFO(): Promise<menuItem[]> {
    return [
      {
        name: 'Félix Oliver',
        path: '/felix-oliver',
        type: 'routerLink',
        listType: null,
        list: [],
      },
      {
        name: 'Sobre Félix Oliver',
        path: '/felix-oliver-about',
        type: 'routerLink',
        listType: null,
        list: [],
      },
      {
        name: 'Catálogo',
        path: '/felix-oliver-catalogue',
        type: 'routerLink',
        listType: null,
        list: [],
      },
      {
        name: 'Suscripciones',
        path: '/felix-oliver-membership-info',
        type: 'routerLink',
        listType: null,
        list: [],
      },
    ];
  }

  getGeneros(): Promise<GenreModelWithURL[]> {
    return new Promise((resolve, reject) => {

      this.genresService.getAllGenres().pipe(
        retry(1),
        map(g => g.filter(ge => ge.enabled)) // Géneros activos
      )
        .subscribe(
          (genres) => {
            // console.log("generos", genres)
            let list = genres.map(g => {
              return {
                id: g.id,
                name: g.name,
                enabled: g.enabled,
                url: `search-genre/${g.id}`,
              }
            })

            resolve(list)
          },
          (error) => {
            console.log(error);
            this.helperService.errorInesperado();
          },
        );

    })
  }


  modalLogin() {
    this.selectModal('modalLogin');
  }

  modalTarjetas() {
    this.selectModal('modalTarjetas');
  }

  cerrarModales() {
    this.cerrarModalesEvent.next(true);

    setTimeout(() => {
      this.cerrarModalesEvent.next(false);
    }, 500);
  }


  abrirMenu() {
    this.menuActive.next(true);
  }

  cerrarMenu() {
    this.menuActive.next(false);
  }

  private selectModal(modal: string) {
    this.modalSelected.next(modal);

    setTimeout(() => {
      this.modalSelected.next(null);
    }, 500);
  }


}
